import { Box, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { FileIcon, useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'

export type OrderNotesButtonProps = {
  notes?: string | null
  operationalInstructions?: string | null
  onClick?: () => void
}

export const OrderNotesButton: FC<OrderNotesButtonProps> = observer(props => {
  const { notes, operationalInstructions, onClick } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const notesCount = (notes ? 1 : 0) + (operationalInstructions ? 1 : 0)

  const chipColor = () => (notesCount ? theme.palette.warning.dark : theme.palette.grey[600])
  const chipBgColor = () => (notesCount ? theme.palette.warning.lighter : theme.palette.grey[200])

  return (
    <Box
      onClick={onClick}
      sx={{
        cursor: 'pointer',
        background: chipBgColor(),
        padding: '4px 8px',
        borderRadius: '4px',
        display: 'flex',
        height: '32px',
      }}
    >
      <Typography
        display={'flex'}
        fontSize={'14px'}
        alignSelf={'center'}
        alignItems={'center'}
        fontWeight={500}
        color={chipColor()}
        gap={1}
        p={0.4}
      >
        <FileIcon />
        {t('xNotes', '{count} notes', {
          count: notesCount,
        })}
      </Typography>
    </Box>
  )
})
